import React from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { resolveActionLabel } from "./lostTerminalAlertsUtils";

export default function LostTerminalActionsMenu({
  item,
  disabled = false,
  onManage,
  onTake,
  onAssign,
  onRelease,
  onCopyMessage,
}) {
  const actionLabel = resolveActionLabel(item);

  return (
    <Dropdown align="end" onClick={(event) => event.stopPropagation()}>
      <Dropdown.Toggle
        type="button"
        variant="dark"
        className="lost-terminal-alert-card__actions-toggle"
        disabled={disabled}
      >
        <span>Acciones</span>
        <FontAwesomeIcon icon={faEllipsis} />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {item.canTake ? <Dropdown.Item onClick={() => onTake?.(item.raw)}>Tomar caso</Dropdown.Item> : null}
        {item.canAssign ? <Dropdown.Item onClick={() => onAssign?.(item.raw)}>Asignar</Dropdown.Item> : null}
        {item.canRelease ? <Dropdown.Item onClick={() => onRelease?.(item.raw)}>Liberar</Dropdown.Item> : null}
        <Dropdown.Item onClick={() => onManage?.(item.raw)}>{actionLabel}</Dropdown.Item>
        {item.suggestedMessage ? <Dropdown.Item onClick={() => onCopyMessage?.(item.suggestedMessage)}>Copiar mensaje</Dropdown.Item> : null}
      </Dropdown.Menu>
    </Dropdown>
  );
}
